<input type="file" #file [hidden]="true" (change)="onFileAdded()" [accept]="accept" />
<app-button *ngIf="label" [buttonClass]="'Button--card'" (clickEvent)="addFile()" [label]="label"></app-button>
